import { apiClient } from '../../../v4/core/apiClient';
import { createBookingApi } from './booking.api.http';
import { myMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService.connected';

export const myBookingApi = createBookingApi({
  client: apiClient,
  services: { metastructureMappingService: myMetastructureMappingService }
});
